{
  "loading": "Caricamento...",
  "loadingMore": "Caricamento altri..."
}
